// 文章1数据信息
export default {
  id: '1',
  title: '7天控糖体验营',
  createTime: '2025-03-20 10:00:00',
  content: `![img](https://cdn.keihong.tech/img/20250422161139203.png)

**适合客户**：想体验短期内血糖恢复正常值的糖友。

**服务时长**： 7天

**服务权益**：

1）**细胞母乳**：7天服用量
2）**血糖监测**：1个连续血糖监测仪
3）**7天连续监督打卡**
4）**轻断食细胞营养疗法**
5）**1次线上运动指导服务（每次20分钟），1套居家训练方案**
6）**控糖老师七天悉心陪伴和答疑**
7）**终身的客户线上咨询与随访**`
}
